import React from "react";
import { WHY_US } from "@/data/site";

export const WhyUs = () => {
  return (
    <section data-testid="why-us-section" className="bg-slate-950 text-white">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-6">
            <div className="overline text-blue-400 mb-6">Why choose us</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-balance">
              Built on precision. Delivered with pride.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pl-16 flex items-end">
            <p className="text-white/70 max-w-lg">
              We combine seasoned installers, certified materials, and an obsessive attention to detail
              — so every project reflects the standard our clients expect.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {WHY_US.map((w, i) => (
            <div
              key={w.title}
              data-testid={`why-us-card-${i}`}
              className="bg-slate-950 p-8 md:p-10 hover:bg-slate-900 transition-colors group"
            >
              <div className="text-[10px] uppercase tracking-[0.22em] text-blue-400/80 mb-6">
                {String(i + 1).padStart(2, "0")}
              </div>
              {w.metric ? (
                <div className="mb-6">
                  <div className="font-display text-5xl font-light text-white">{w.metric}</div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-white/50 mt-1">
                    {w.metricLabel}
                  </div>
                </div>
              ) : (
                <div className="h-[76px] mb-6" />
              )}
              <h3 className="font-display text-lg font-medium">{w.title}</h3>
              <p className="mt-3 text-sm text-white/60 leading-relaxed">{w.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
